export default __webpack_public_path__ + "static/media/assigned.bf774585.png";